import { Icon } from "@mui/material";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { StyledText } from "../../components/Text";
import theme from "../../styles/theme";
import styled from "styled-components";
import { CustomBlock, StyledImg } from "../../components/CompetenciesList";
import { Icon as MuiIcon } from "@mui/material";
import defaultImg from "../../assets/DefaultCardImage.png";
// import { motion } from "framer-motion";

interface Competency {
  template_pillar_id: string;
  pillar_title: string;
  id: string;
  title: string;
  competency_code: string;
  subdomain_title: string;
  description: string;
  required: boolean;
  credits: any;
  status_val: any;
  status: any;
  mastery_level: any;
  mastery_level_title: any;
  transferred: any;
  earned: any;
  curriculum_version: any;
  total_skills: any;
  assessed_skills: any;
  skills: any;
  card_history_events: any;
  affect_gpa: any;
  semester_name: any;
  university_code: any;
  graphics: any;
}
interface Cards {
  competencies: Competency[];
  pillar_title: string;
  template_pillar_id: string;
}
interface Props {
  selectedPillar: Cards;
  setSelectedCompetency: (x: any) => void;
  setIsDetailModalOpen: (x: any) => void;
  setSelectedPillar: (x: any) => void;
}
type BlockProps = {
  backgroundColor: string;
};
const CustomAssessmentBlock = styled(FlexGrow)<BlockProps>`
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  text-align: center;
  border-radius: 12px;
  // border-radius: 12px;
  background: ${({ backgroundColor }) => backgroundColor};
  box-shadow: black 0px 1px 4px 0px;
  padding: 16px;
  flex-grow: 0;
  cursor: pointer;
  width: 171px;
  min-width: 171px;
  max-width: 171px;
  height: 270px;
  min-height: 270px;
  max-height: 270px;
  overflow: hidden;
`;

const fanOutAnimation = {
  initial: {
    opacity: 0, // Start invisible
    x: 300, // Cards start from the "host" position
    y: 500,
    scale: 0.5, // Cards start smaller
    rotate: -150, // Start with a slight spin
  },
  animate: (index: number) => ({
    opacity: 1, // Fade in
    x: 0, // Move to their relative position
    y: 0, // Move to their relative position
    scale: 1, // Full size
    rotate: 0, // Spin back to normal position
    transition: {
      opacity: { duration: 0.1, delay: index * 0.1 }, // Staggered fade-in to avoid blinking
      type: "spring", // Smooth spring animation
      stiffness: 150,
      damping: 20,
      delay: index * 0.1, // Stagger animation by index
    },
  }),
};

export const CompetencyList = (props: Props) => {
  const {
    selectedPillar,
    setSelectedPillar,
    setIsDetailModalOpen,
    setSelectedCompetency,
  } = props;

  return (
    <>
      <FlexBox justify="start" style={{ padding: 5 }}>
        <FlexBox
          onClick={() => setSelectedPillar(null)}
          style={{ cursor: "pointer", gap: 4 }}
        >
          <Icon>reply_icon</Icon> Back to All Pillars
        </FlexBox>
      </FlexBox>
      <FlexBox
        className="visible-scrollbar"
        alignItems="flex-start"
        style={{
          marginBottom: theme.spacing.x2,
          marginTop: theme.spacing.x2,
          minHeight: "75vh",
          maxHeight: "75vh",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {selectedPillar.competencies
          .sort((a: any, b: any) =>
            a.competency_code.localeCompare(b.competency_code)
          )
          .map((d: any, index: number) => (
            // <motion.div
            //   whileHover={{ scale: 0.98 }}
            //   whileTap={{ scale: 1.05 }}
            //   key={d.id}
            //   custom={index} // Pass index to control animation
            //   variants={fanOutAnimation}
            //   initial="initial"
            //   animate="animate"
            //   style={{
            //     //   position: "absolute", // Positioning for animations
            //     zIndex: index, // Proper stacking order
            //   }}
            // >
            <FlexBox
              direction="column"
              space={0}
              style={{
                marginBottom: "13px",
              }}
            >
              {console.log("==> Rendering Competency:", d.title, "Status:", d.status, "InstructorApproved:", d.instructor_approved)}
              <CustomBlock
                backgroundColor={d.graphics?.iconbg || "#23273e"}
                onClick={() => {
                  setSelectedCompetency(d);
                  setIsDetailModalOpen(true);
                }}
              >
                <div style={{ padding: "5px 0px" }}>
                  <StyledText fontWeight="700">{d.competency_code}</StyledText>
                </div>
                <StyledImg
                  src={
                    d.graphics?.imgurl
                      ? process.env.REACT_APP_IMG_URL + d.graphics.imgurl
                      : defaultImg
                  }
                  alt=""
                />
                <MuiIcon
                  sx={{
                    color: "white",
                    padding: "6px",
                    background: d.graphics?.iconbg || "#23273e",
                    borderRadius: "100px",
                    fontSize: "27px",
                    position: "absolute",
                    bottom: "105px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    boxShadow: d.graphics?.iconshadow,
                  }}
                >
                  {d.graphics?.icon || "help"}
                </MuiIcon>{" "}
                <StyledText
                  style={{
                    minHeight: 90,
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  fontWeight="700"
                >
                  {d.title}
                </StyledText>
              </CustomBlock>
              {d.instructor_approved === false && (d.status === "In progress" || d.status === "Selected" || d.status === "Completed") && (
                <FlexGrow style={{ width: "100%" }}>
                  <div
                    style={{
                      textAlign: "center",
                      background: "linear-gradient(135deg, #b45309, #d97706)",
                      borderBottomRightRadius: "12px",
                      borderBottomLeftRadius: "12px",
                      transform: "translateY(-10px)",
                      padding: "2px 0",
                      animation: "ao-pulse 2s ease-in-out infinite",
                    }}
                  >
                    <StyledText
                      style={{
                        lineHeight: "30px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        fontSize: "0.7rem",
                        color: "#fff",
                        letterSpacing: "0.5px",
                      }}
                    >
                      ⏳ Pending Approval
                    </StyledText>
                  </div>
                </FlexGrow>
              )}
              {(d.status === "Recorded" || d.status === "Completed" || (d.status === "Archived" && d.mastery_level_title)) && (
                <FlexGrow style={{ width: "100%" }}>
                  <div
                    style={{
                      textAlign: "center",
                      background: "white",
                      // paddingTop: "8px",
                      borderBottomRightRadius: "12px",
                      borderBottomLeftRadius: "12px",
                      transform: "translateY(-10px)",
                    }}
                  >
                    <StyledText
                      style={{
                        lineHeight: "30px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        fontSize: "0.8rem",
                        color: "rgb(107 45 45)",
                      }}
                    >
                      {d.status} : {d.mastery_level_title}
                    </StyledText>
                  </div>
                </FlexGrow>
              )}
            </FlexBox>

            // </motion.div>
          ))}
      </FlexBox>
    </>
  );
};
